import React from "react";
import Editor from "./Editor";
import Contacts from "../../models/Contacts";
import Subscription from "../../models/Subscription";
import {MailController} from '../../controller/MailController';
import {isMobile} from 'react-device-detect';
import { Input, Button, Chip, Drawer, Container, Stack, Typography, Tooltip, FileUpload, Flex, FormControl, IconButton } from "@airbus/components-react";
import { Cancel} from "@airbus/icons/react";
import { Add } from "@airbus/icons/react";
import CustomMultiSelect from "../CustomMultiSelect";

import "../../css/FileUpload.css";
import '../../css/Forms.css';

class Mailbox extends React.Component {


    constructor(props){
        super(props);

        //cstes
        this.MAX_CHIPS_DISPLAY = 2;

        //all contacts containers
        this.contacts = [];
        this.subscriptions=[];

        //notif
        this.setNotification=this.props.notificationHandler;  //call parent notification handler

        //states
        this.state={
          
          emailTo: [],                        //mixed user contacts and subscriptions 
          mailsTo: [],                        //contains all mails to
          emailCC: [],                        //mixed user contacts and subscriptions
          mailsCC: [],                        //contains all mails cc
          emailBCC: [],
          mailsBCC: [],
          emailSubject: "",
          emailBody: "",
          filteredContactsOptions: [],
          contactsOptions: [],                //list of available contacts options
          files: [],
          uploadComplete: false,
          drawerDetailsOpen: false,           //Display mail details
          drawerDetailsAnchor:'right',        //Configuration details Position
          drawerDetailsMailxx: '',
          windowWidth: window.innerWidth,     //screen width 
          windowHeight: window.innerHeight,   //screen height         
        }

        this.mailcontroller = new MailController();

    }

    componentDidMount = async() => {
      let _=require("underscore");
      window.addEventListener("resize", this.handleResize);

      //change label for browse file (upload) => failure on mobile
      //console.log(isMobile);
      if(!isMobile){
        //debugger;
        let elements=document.getElementsByClassName("custom_fileupload");

        if(elements !== undefined && elements !== null){

          _.each(elements, function(element){

            if(element.getElementsByTagName("span").length > 0){

              let innerhtml=element.getElementsByTagName("span")[0].innerHTML;
              let textcontent = element.getElementsByTagName("span")[0].textContent;
              element.getElementsByTagName("span")[0].innerHTML = innerhtml.replace(textcontent, ' Ajouter Fichier');
              
              
            }

          });
        }
      }

      //init contacts
      this.contacts = await new Contacts().getContacts();

      //init subscriptions
      this.subscriptions = new Subscription();
      await this.subscriptions.setCategories();
       

      //debugger;

      //Contacts list & subscriptions
      let contacts = _.sortBy(_.map(this.contacts, function(item){

        let label="";

        if(!(item.nom==='' && item.prenom==='')){
          label=(item.nom+" "+item.prenom).split(" ").filter(e=>e).join(" ")

            return {
              label: label,
              value: item.id,
              mail: item.mail,
              type: 'user',
              group: 'Contacts'
          }

        }else{
          label=item.mail;

          return {
              label: label,
              value: item.id,
              mail: item.mail,
              type: 'user',
              group: 'Contacts (mail seulement)'
          }
        }

        

      }),'label');

      //add subscriptions to contacts
      let subscriptions = _.map(this.subscriptions.getCategories(), function(item){
        return {
          label: item.category,
          value: item.id,
          type: 'subscription',
          group: 'Abonnements'
        }
      });

      this.setState({contactsOptions:subscriptions.concat(contacts), filteredContactsOptions:subscriptions.concat(contacts)}, 
        ()=>{
          //debugger;
          //console.log(this.state.contactsOptions)
        }
      );

    }


    componentDidUpdate = () => {
      
      window.addEventListener("resize", this.handleResize);
      
      //Handle Files upload behaviour
      if (this.state.files.length > 0 && !this.state.uploadComplete) {

        const interval = setInterval(() => {
          let successCount = 0;
          const updatedFiles = this.state.files.map((file) => {
            if (file.status === "added") {
              return { ...file, status: "uploading", percentage: 10 };
            } else if (file.status === "uploading" && file.percentage <= 100) {
              return { ...file, percentage: file.percentage + 10 };
            } else if (file.status === "error") {
              return { ...file, status: "error" };
            } else {
              successCount++;
              return { ...file, status: "success" };
            }
          });

          this.setState({ uploadComplete:successCount === updatedFiles.length,
                          files: updatedFiles
          });

          if(successCount === updatedFiles.length){
            clearInterval(interval);
          }

         
          
        }, 500);

        //return () => clearInterval(interval);

      }

    }


    

    /*Handle screen size*/
    handleResize = (e) => {
      
      //debugger;
      this.setState({ 
          windowWidth: window.innerWidth,
          windowHeight: window.innerHeight
      });
  
      };


    /**
     * RENDERING
     * @returns dom
     */
     render() { return(
        <Container style={{paddingLeft:"40px", paddingTop:"10px"}}>
        <div className="panel panel-default">

           
            {/*TO*/}
            <Container until="sm" className="container-left" style={{paddingTop:"10px", paddingLeft:0, paddingRight:0}}>
              <Flex wrap={true} direction="row" >
                <Chip size="small" icon={<Add/>} label="to" clickable onClick={()=>this.openContacts("to")} />
                {this.state.mailsTo.map((mail, i)=>(
                  i<this.MAX_CHIPS_DISPLAY ?
                  <Chip size="small" label={mail} style={{marginLeft:"5px"}}/>
                  : i===this.MAX_CHIPS_DISPLAY &&
                    <Tooltip placement="bottom" label={this.state.mailsTo.slice(this.MAX_CHIPS_DISPLAY).join(", ")}>
                      <Chip size="xsmall" label={"+"+String(this.state.mailsTo.length-i)} style={{marginLeft:"5px"}}/>
                    </Tooltip>  
                ))}
              </Flex>
            </Container>

            {/*CC*/}
            <Container until="sm" className="container-left" style={{paddingTop:"10px" , paddingLeft:0, paddingRight:0}}>
              <Flex wrap={true} direction="row" >
                    <Chip size="small" icon={<Add/>} label="cc" clickable onClick={()=>this.openContacts("cc")}/>
                    {this.state.mailsCC.map((mail, i)=>(
                      i<this.MAX_CHIPS_DISPLAY ?
                      <Chip size="small" label={mail} style={{marginLeft:"5px"}}/>
                      : i===this.MAX_CHIPS_DISPLAY &&
                        <Tooltip placement="bottom" label={this.state.mailsCC.slice(this.MAX_CHIPS_DISPLAY).join(", ")}>
                          <Chip size="xsmall" label={"+"+String(this.state.mailsCC.length-i)} style={{marginLeft:"5px"}}/>
                        </Tooltip>  
                    ))}
              </Flex>
            </Container>

            {/*CCi*/}
            <Container until="sm" className="container-left" style={{paddingTop:"10px" , paddingLeft:0, paddingRight:0}}>
              <Flex wrap={true} direction="row" >
                    <Chip size="small" icon={<Add/>} label="bcc" clickable onClick={()=>this.openContacts("cci")}/>
                    {this.state.mailsBCC.map((mail, i)=>(
                      i<this.MAX_CHIPS_DISPLAY ?
                      <Chip size="small" label={mail} style={{marginLeft:"5px"}}/>
                      : i===this.MAX_CHIPS_DISPLAY &&
                        <Tooltip placement="bottom" label={this.state.mailsBCC.slice(this.MAX_CHIPS_DISPLAY).join(", ")}>
                          <Chip size="xsmall" label={"+"+String(this.state.mailsBCC.length-i)} style={{marginLeft:"5px"}}/>
                        </Tooltip>  
                    ))}
              </Flex>
            </Container>

            {/*Subject*/}
            
              
                <Container until="sm" className="container-left" style={{paddingTop:"10px", paddingLeft:"0px", paddingRight:"0px"}}>
                
                  <Flex wrap={true} direction="row" >
                        <Input  placeholder='Objet' 
                                value={this.state.emailSubject} 
                                style={{width: '100%'}}
                                onChange={this.handleEmailSubjectChange} />
                        
                        
                  </Flex>
                </Container>

              
                
                {/*Body*/}
                
                <Container until="lg" className="container-left" style={{paddingLeft:0, paddingRight:0}}>

                  <Flex wrap={true} direction="row" >
                    <Container until="sm" className="container-left" style={{paddingLeft:0, paddingRight:0}}>
                      <Editor onChange={this.handleEditorChange}
                            body={this.state.emailBody} />
                    </Container>

                    <Container until="xxs" className="container-left" style={{paddingLeft:0, paddingRight:0}}>
                    
                    <FileUpload
                      className="custom_fileupload"
                      multiple
                      onAdd={this.handleAddFile}
                      onDelete={this.handleDeleteFile}
                      files={this.state.files}
                    />
                    </Container>
                  </Flex>
                </Container>



                {/*SUBMIT*/}
                
                    
                <Flex wrap={true} direction="row" >
                  <FormControl className="button-controlForm" style={{paddingLeft:"0px"}}> 
                    <Button variant="primary" 
                                    onClick = {this.onSend}
                                    style={{
                                        width: "100%"
                                        }}>
                                    Envoyer
                    </Button>
                  </FormControl>
                </Flex>
                
              

              {/**<Stack style={{height:"400px", overflowY:"auto"}}>
                
              </Stack>**/}
            

            {/**
             * Modal mails
             */}
            {this.state.filteredContactsOptions.length > 0 &&
            <Drawer  open={this.state.drawerDetailsOpen} theme='light' anchor={this.state.drawerDetailsAnchor} onClose={() => this.setState({drawerDetailsOpen:false})}>
              <div  style={{
                    [this.state.drawerDetailsAnchor === "left" || this.state.drawerDetailsAnchor === "right" ? "width" : "height"]: 750,
                    paddingTop: 150,
                    paddingLeft:10,
                    overflow:'hidden',
                    maxWidth: this.state.windowWidth
                }}>

                <Container style={{height:this.state.windowHeight-180}}>
                    <div><IconButton variant="ghost" style={{color:'red'}} onClick={()=>this.setState({drawerDetailsOpen:false})}><Cancel /></IconButton></div>
                    {this.state.drawerDetailsMailxx === 'to' ?
                      <Typography variant="h6">Destinataires:</Typography>
                    :this.state.drawerDetailsMailxx === 'cc' ?
                      <Typography variant="h6">Copies:</Typography>
                    :this.state.drawerDetailsMailxx === 'cci' ?
                      <Typography variant="h6">Copies cachées:</Typography>
                    :null}
                    <Stack spacing="2-x" >
                      
                      {this.state.filteredContactsOptions.length > 0 && 
                        <CustomMultiSelect
                          mykey={Math.random()}
                          options={this.state.filteredContactsOptions}
                          selectedValues={
                            this.state.drawerDetailsMailxx === 'to' ? this.state.emailTo:
                            this.state.drawerDetailsMailxx === 'cc' ? this.state.emailCC:
                            this.state.drawerDetailsMailxx === 'cci' ? this.state.emailBCC:[]
                          }
                          displayValue={["label"]}
                          id="value"
                          groupBy="group"
                          multiple={true}
                          selectAll={false}
                          unSelectAll={true}
                          callBack={this.onChangeSelectedContacts}
                          callBackEmpty={this.onCreateContact}
                    
                      />  
                        
                      }
                    </Stack>
                    <Stack>
                        <ul>
                          
                          {this.state.drawerDetailsMailxx === 'to' ?
                            //email to list
                            
                           
                            
                            this.state.mailsTo.map((item)=>(

                              <li>{item}</li>

                            ))
                            
                          :this.state.drawerDetailsMailxx === 'cc' ?
                            //email cc list
                            
                            
                            this.state.mailsCC.map((item)=>(

                              <li>{item}</li>

                            ))
                            
                          :this.state.drawerDetailsMailxx === 'cci' ?
                            //email bcc list
                            
                            this.state.mailsBCC.map((item)=>(
                              <li>{item}</li>
                            ))
                          
                          :null}
                        </ul>
                    </Stack>
                </Container>

              </div>
            
            </Drawer>
            }
        
        
        </div>

        

        </Container>
    )}

    /**
     * EVENTS
     */
    
     handleEditorChange = (emailBody) => {
        //debugger;
        this.setState({ emailBody: emailBody });
        
      }
      

      handleEmailSubjectChange =  (e) => {
        this.setState({ emailSubject: e.target.value });
      }

      handleCancelClick = () => {
        this.setState({
          emailTo: "",
          emailCC: "",
          emailBCC: "",
          emailSubject: "",
          emailBody: ""
        });
      }

      /*Manage mail to, cc, bcc contacts*/ 
      openContacts = (mailxx) =>{
        this.setState({drawerDetailsOpen:true, drawerDetailsMailxx:mailxx})
      }

      /**
       * Get list of mails from contacts and subscriptions
       * @param {object} contact_subs : mixed contacts and subscriptions
       * @returns array
       */
      getMailsFromContactsAndSubsscriptions= async (contact_subs) =>{
        
        let _ = require("underscore");

        let out= await Promise.all(_.map(contact_subs, async function(item){

          if(item.hasOwnProperty('mail')){
            return item.mail;
          }else if(item.type === 'subscription'){
            //retrieve all contacts from selected subscription
            
            let subscribed_users = await this.subscriptions.getCategoryById(item.value);

            let subscribed_mails=[];
            _.each(subscribed_users.contacts, function(item){

              subscribed_mails.push(item.mail);

            });

            return subscribed_mails;


          }
          

        }, this))
        
        return  _.sortBy(_.uniq(_.flatten(out)));

      }

      /**
       * on new contact direct creation
       */
      onCreateContact=(value, ref)=>{
        let _ = require("underscore");
        let contacts = this.state.contactsOptions;
        let selectedContacts = _.filter(ref.current.getSelectedItems(), function(item){
          return item.type === 'custom'
        });

        
        let result = _.filter(ref.current.state.options, function(item){
            return item['label'].toLowerCase().includes(value.toLowerCase());
        }, this);

        if(result.length === 0){
          let new_contact = [{
            label: value,
            value: value,
            mail: value,
            type: 'custom',
            group: 'emails manuels'
          }]
          
          this.setState({filteredContactsOptions:new_contact});
        }else{
          //debugger
          this.setState({filteredContactsOptions: selectedContacts.concat(contacts)});
        }

      }

      //On contact change selection
      onChangeSelectedContacts = async (values, ref) => {
        
        let _ = require("underscore");
        let contacts = this.state.contactsOptions;
        let selectedContacts = _.filter(ref.current.getSelectedItems(), function(item){
          return item.type === 'custom'
        });
        //debugger;
        
        //retrieve list of all mails
        let mails = await this.getMailsFromContactsAndSubsscriptions(values);

        //save mail to selected
        if(this.state.drawerDetailsMailxx === 'to'){
          this.setState({emailTo:values, mailsTo:mails, filteredContactsOptions: selectedContacts.concat(contacts)});
        }else if(this.state.drawerDetailsMailxx === 'cc'){
          this.setState({emailCC:values, mailsCC:mails, filteredContactsOptions: selectedContacts.concat(contacts)});
        }else if(this.state.drawerDetailsMailxx === 'cci'){
          this.setState({emailBCC:values, mailsBCC:mails, filteredContactsOptions: selectedContacts.concat(contacts)});
        }
        
        
      }

      comboGroupBy=(option)=>{
        //debugger;
        //console.log(option);
        return option.group;
        //debugger;

      }

      /*SEND MAIL*/
      onSend = async () =>{

        //upload files
       // await this.onFileUpload();


        let response = await this.mailcontroller.sendMail(this.state.mailsTo, 
                                                    this.state.mailsCC, 
                                                    this.state.mailsBCC,
                                                    this.state.emailSubject,
                                                    this.state.emailBody,
                                                    this.state.files
                                                  );
        //debugger;
        if(response && response.hasOwnProperty('success') && response.success===true){

          this.setNotification(true,{
            notifVariant: "success",
            notifMessage:"Mail envoyé",
            notifDescription:"Mail envoyé à "+String(this.state.mailsTo.length+this.state.mailsCC.length+this.state.mailsBCC.length)+" personnes"
          });

        }else if(response && response.hasOwnProperty('success') && response.success===false){


          this.setNotification(true,{
            notifVariant: "error",
            notifMessage:"Erreur envoi mail",
            notifDescription:JSON.stringify(response.responseDescription)
          });

        }else{

          this.setNotification(true,{
            notifVariant: "error",
            notifMessage:"Erreur envoi mail",
            notifDescription:null
          });

        }

      }


      

      //Upload management
      //-----------------

      //delete file
      handleDeleteFile = (id) => {
        //debugger;
        let fileList = [...this.state.files];
        let index = fileList.findIndex((file) => file.id === id);
        fileList.splice(index, 1);
        this.setState({files: fileList});
      };


      /**
       * Add files
       * @param {*} newFiles List of files
       */
      handleAddFile = (newFiles) => {
        
        //debugger;
        this.setState({uploadComplete: false, files:[...newFiles, ...this.state.files]});
      };


      


      


}

export default Mailbox;